define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/state",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,Ref,state,xml,Query) {

	return declare(Ref, {
		_getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {

			const quoteRev = ctx.getNode();
			const quote = ctx.cache.getNode(quoteRev.__Parent__);
			const productSource = ctx.cache.getNode(quote.__Parent__);
			let pathToQueryBOMDataSheets;
			if(xml.isValidURL(productSource.DataSheets)){
				 pathToQueryBOMDataSheets = "Child:__Parent__/Child:__Parent__";
			}else{
				 pathToQueryBOMDataSheets = "Child:__Parent__/Child:__Parent__/Child:__Parent__";
			}
			let viewRef = lang.mixin(new ViewRef(), {
				m_id: "AggregateBOM",
				m_path: pathToQueryBOMDataSheets,
				m_url: quoteRev.$URL
			});
			const productSourcingUrl = ctx.view.nodeProduct?.ProductSourcing;
			if(productSourcingUrl && xml.isClientUrl(quoteRev.$URL)) {
				viewRef = lang.mixin(new ViewRef(), {
					m_id: "AggregateBOM",
					m_url: productSourcingUrl
				});
			}
			return lang.mixin(new Action(), {
				m_fixedQuery: new Query()
					.Attr("State", xml.OP_NOT_EQUALS, "Revision.State:ABANDONED", "Child:CurrentRevision"),
				m_viewRef: viewRef
			});
		},

		/**
		 * @override
		 * Prevent action if the user does not have access to QuoteBOM
		 */
		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			const productSourcing = ctx.getNodeParent(ctx.getNodeParent());
			if(state.get("userType") == "Supplier" || (productSourcing && productSourcing.$Type !== "ProductSource")) {
				return null;
			}
			return this.inherited(arguments);
		},
	});
});